import React, { ReactNode } from 'react'

interface IInput {
    changeHandler: (data: any) => any,
    blurHandler?: (data: any) => any,
    value: string,
    placeholder?: string,
    disabled?: boolean,
    label?: string | ReactNode
    name: string,
    customClassName?: string,
    customLabelClassName?: string,
    customLabel?: React.ComponentType<{}>
    validationError?: boolean,
    validationErrorDescription?: string,
    require?: boolean,
    id?: string,
    rows?: number
}

const Textarea: React.FC<IInput> = (
    {
        changeHandler,
        placeholder,
        disabled = false,
        label,
        name,
        customClassName,
        customLabelClassName,
        customLabel,
        validationError,
        validationErrorDescription,
        value,
        blurHandler,
        require = true,
        id,
        rows = 2
    }
) => {

    // @ts-ignore
    return (
        <>
            {customLabel ?
                (
                    <div className="flex">
                        {/*@ts-ignore*/}
                        {customLabel}
                    </div>
                )
                :
                label &&
                (
                    <>
                        <label
                            className={`block text-gray-600 text-left font-medium mb-1 ${customLabelClassName ? customLabelClassName : ""}`}
                            htmlFor={name}
                        >
                            {label}
                            {require && <span className="text-red-500 px-1">*</span>}
                        </label>
                    </>
                )
            }
            <textarea
                id={id}
                className={`form-input border px-2 py-1 border-slate-200 rounded-md w-full ${customClassName ? customClassName : ""} ${validationError ? "border border-red-500" : ""}`}
                name={name}
                onChange={changeHandler}
                onBlur={blurHandler}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                required={require}
                rows={rows}
            />
            {
                validationErrorDescription && (
                    <div className="text-xs text-left text-red-500">
                        {validationErrorDescription}
                    </div>
                )
            }
        </>
    )
}

export default Textarea